jQuery(document).ready(function() {
  
//get current language
      var checkCurrentLang = $('html').attr('dir');
     
//check for mobile breakpoints
    var isMobile = window.matchMedia("only screen and (max-width: 760px)").matches;

  

//change button "buy it now" to Arabic language on Single product page
    if (isMobile) {
      
//change text on mobile view:
     setTimeout(function(){
       checkCurrentLang == "rtl" && $('.template-product .shopify-payment-button__button--unbranded').text('شراء الان').attr("style","color:#000!important");
    },2000)
 
    } else {
      
//change text on desktop view: 	     
      setTimeout(function(){
        checkCurrentLang  == "rtl" && $('.template-product .shopify-payment-button__button').text('شراء الان').attr("style","color:#000!important");
      },1000)
      
    }
  
//change text "Register new account" to Arabic language on login page 
  function change_login_new_register_text(){
   
    return checkCurrentLang  == "rtl" && $(".wrapper-login-customer .wrapper-content .col-right .title").text("إنشاء حساب").attr("style","color:#404040!important");
    
  }
  
  change_login_new_register_text()
      
      
    
 
});